export default {
  props: {
    validations: { type: Object }
  },
  computed: {
    showError() {
      return (this.validations && this.validations.$error) || undefined
    }
  },
  methods: {
    verifyValidation() {
      this.validations && this.validations.$touch()
    }
  }
}
